export default {
    modules: {
        adaptiveHeader: {
            state: {
                header: false
            },
            mutations: {
                changeHeaderState: (state) => {
                    state.header = !state.header
                    if (state.header === true) {
                        document.body.style.overflow = 'hidden';
                    } else {
                        document.body.style.overflow = 'auto';
                    }
                },
                changeHeaderTrue: (state) => {
                    state.header = true
                    if (state.header === true) {
                        document.body.style.overflow = 'hidden';
                    } else {
                        document.body.style.overflow = 'auto';
                    }
                },
                changeHeaderFalse: (state) => {
                    state.header = false
                    if (state.header === true) {
                        document.body.style.overflow = 'hidden';
                    } else {
                        document.body.style.overflow = 'auto';
                    }
                }
            },
            actions: {
                toggleHeaderState ({commit}) {
                    commit('changeHeaderState')
                },
                trueHeaderState ({commit}) {
                    commit('changeHeaderTrue')
                },
                falseHeaderState ({commit}) {
                    commit('changeHeaderFalse')
                }
            },
            getters: {
                headerState(state) {
                    return state.header
                }
            },
        },
        headerHeight: {
            state: {
                heightHeader: 0
            },
            mutations: {
                SEARCH_HEADER_HEIGHT: (state) => {
                    let header = document.querySelector('.header').clientHeight;
                    state.heightHeader = header + 'px'
                }
            },
            actions: {
                UPDATE_HEADER_HEIGHT ({commit}) {
                    commit('SEARCH_HEADER_HEIGHT')
                }
            },
            getters: {
                HEADER_HEIGHT (state) {
                    return state.heightHeader
                }
            },
        },
        headerLang: {
            state: {
                langHeader: 'en',
                otherLang: 'ru',
                ruLang: 'ru',
                enLang: 'en'
            },
            mutations: {
                TOGGLE_HEADER_LANG: (state) => {
                    if (state.langHeader === state.enLang) {
                        state.langHeader = state.ruLang
                        state.otherLang = state.enLang
                    } else {
                        state.langHeader = state.enLang
                        state.otherLang = state.ruLang
                    }
                }
            },
            actions: {
                UPDATE_HEADER_LANG ({commit}) {
                    commit('TOGGLE_HEADER_LANG')
                }
            },
            getters: {
                HEADER_LANG (state) {
                    return state.langHeader
                },
                OTHER_LANG (state) {
                    return state.otherLang
                }
            },
        }
    }
}
